export default function Hero() {
  const handleNavigate = () => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE('/guide');
    }
  };

  return (
    <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <iframe
          src="https://player.vimeo.com/video/1151695031?background=1&autoplay=1&loop=1&byline=0&title=0&muted=1"
          className="w-full h-full object-cover"
          style={{ border: 'none', position: 'absolute', top: '50%', left: '50%', width: '100vw', height: '100vh', transform: 'translate(-50%, -50%)', minWidth: '100%', minHeight: '100%' }}
          allow="autoplay; fullscreen; picture-in-picture"
          title="Background Video"
        ></iframe>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-7xl font-light text-white mb-6 tracking-wide">
          腕元からはじまる、<br />贅沢な時間
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-4 font-light tracking-wider">
          Timeless Elegance
        </p>
        <p className="text-lg md:text-xl text-white/80 mb-12 font-light">
          永遠の優雅を、あなたの腕に
        </p>
        <div className="flex justify-center">
          <button
            onClick={handleNavigate}
            className="px-10 py-4 bg-amber-600 text-white text-base font-medium rounded-md hover:bg-amber-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            高級腕時計ガイドを見る
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/70 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
